module.exports = __webpack_public_path__ + "static/media/img192.601bd679.jpg";